import { render } from "./ContentButton.vue?vue&type=template&id=73d714b8"
import script from "./ContentButton.vue?vue&type=script&lang=js"
export * from "./ContentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__